import { useState } from 'react';

import { useLocalStorage } from 'common/hooks/useLocalStorage';
import { SnappyIntegrationConfig } from 'settings/Settings.types';

const DONT_SHOW_AGAIN_MODAL_KEY = 'positive_feedback:dismiss_snappy_prompt';

interface ConnectWithSnappyDialogResponse {
  isVisible: boolean;
  dontShowAgain: boolean;
  closeDialog: () => void;
  setDontShowAgain: (dontShowAgain: boolean) => void;
}

export function useConnectWithSnappyDialog(
  config: SnappyIntegrationConfig
): ConnectWithSnappyDialogResponse {
  const [dontShowAgain, setDontShowAgain] = useLocalStorage(
    DONT_SHOW_AGAIN_MODAL_KEY,
    false
  );
  const [isVisible, setIsVisible] = useState(
    !(config.active || dontShowAgain)
  );

  // If the user has configured Snappy, we don't show the integration dialog as
  // it is not needed anymore. We only want to show the dialog to users who are
  // using Stella Rewards.
  // We only want to show the “dialog” in case the don’t show again option is
  // not active.
  return {
    isVisible,
    dontShowAgain,
    setDontShowAgain,
    closeDialog: () => setIsVisible(false),
  };
}
